/**
 * Parses a URL param into a finite number, returning undefined for missing,
 * empty, or non-finite values. Shared between per-tab URL modules so
 * their number-parsing semantics stay identical.
 */
export function parseFiniteNumber(rawText: string | null | undefined): number | undefined {
  if (rawText === '' || rawText == undefined) return undefined;
  const parsed = Number(rawText);
  return Number.isFinite(parsed) ? parsed : undefined;
}

/**
 * Parses a URL param into a non-negative integer, returning undefined for missing,
 * empty, non-integer (`42.5`), or negative values. Prevents `?from_stop=42.5`
 * from becoming an `origin_stop_id=42.5` the backend then 400s on.
 */
export function parseNonNegativeInt(rawText: string | null | undefined): number | undefined {
  const parsed = parseFiniteNumber(rawText);
  if (parsed === undefined || !Number.isSafeInteger(parsed) || parsed < 0) return undefined;
  return parsed;
}
